import BaseLayout from '../../components/layout/layout-with-sider/BaseLayout';
import {Button, Card, Result, Tabs,} from 'antd';
import React, {useEffect, useState} from 'react';
import {AppActions, useAppContext} from '../../context/AppContext';
import {tab} from '@testing-library/user-event/dist/tab';
import {useHistory} from 'react-router-dom';
import RunOperations from './RunOperations';
import LMA from './LMA';
import SurveyAutomationTab from "./SurveyAutomationTab";
import XSAutomationTab from "../xs-automation/XSAutomationTab";

export default function Run() {
    const [runType, setRunType] = useState('Check');
    const history = useHistory();
    const { appContext, dispatchProject, selectedHistoryId, selection } = useAppContext();

    const selectFirst = () => {
        let project = null;
        let plan = null;
        let river = null;
        let survey = null
        if (appContext?.projects?.length > 0) {
            project = appContext?.projects[0];
            const surveyFiles = project?.shapeFiles?.filter(x => x.hasSurveyData);
            if(surveyFiles?.length > 0) {
                survey = {...surveyFiles[0]}
            }

            if (project?.projectFiles?.length > 0) {
                plan = project.projectFiles[0];
                if (plan?.rivers?.length > 0) {
                    river = plan.rivers[0];
                }
            }
        }

        const selection = {
            project: {...project},
            plan: {...plan},
            river: {...river},
            survey: {...survey}
        };

        const _existBase = appContext?.projects?.find(x => x.id === appContext?.selection?.base?.project?.id);
        const _existCmp = appContext?.projects?.find(x => x.id === appContext?.selection?.compare?.project?.id);

        const appSelection = {
            base: (appContext?.selection?.base?.project && _existBase) ? appContext?.selection?.base : selection,
            compare: (appContext?.selection?.compare?.project && _existCmp) ? appContext?.selection?.compare : selection,
        };

        dispatchProject({
            type: AppActions.SET_PROJECT_SELECTION,
            data: {
                selection: {
                    ...appSelection,
                },
            },
        });
    };

    useEffect(() => {
        selectFirst();
    }, []);
    
    return (
        <div>
            {appContext?.projects?.length === 0 && (
                <Result
                    style={{ backgroundColor: 'white' }}
                    title='There are no Uploaded Projects!'
                    extra={
                        <Button
                            size={'small'}
                            type='primary'
                            key='console'
                            onClick={() => {
                                history.push('/app/load-project');
                            }}
                        >
                            Upload project and run
                        </Button>
                    }
                />
            )}
            {appContext?.projects?.length > 0 && (
                <BaseLayout>
                <Card
                        title={
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                    }}
                                >
                                    <Tabs
                                        onChange={(tab) => setRunType(tab)}
                                        tab={tab}
                                        type={'card'}
                                        defaultActiveKey={'Check'}
                                        hideAdd={true}
                                        size={'small'}
                                        moreIcon={false}
                                    >
                                        <Tabs.TabPane
                                            tab={'Check'}
                                            key={'Check'}
                                        />
                                        <Tabs.TabPane
                                            tab={'Comparison'}
                                            key={'Comparison'}
                                        />
                                        <Tabs.TabPane
                                            tab={'Library Model Automation'}
                                            key={'LMA'}
                                        />
                                        <Tabs.TabPane
                                            tab={'Survey Automation'}
                                            key={'structure-generate'}
                                        />
                                        <Tabs.TabPane
                                            tab={'XS Automation'}
                                            key={'xs-automation'}
                                        />
                                    </Tabs>
                                </div>
                            </div>
                        }
                    >
                        {['Check', 'Comparison'].includes(runType) && (
                            <RunOperations runType={runType} />
                        )}
                        {
                            runType === 'LMA' && (
                                <LMA />
                            )
                        }
                    {
                        runType === 'structure-generate' && (
                            <SurveyAutomationTab />
                        )
                    }
                    {
                        runType === 'xs-automation' && (
                            <XSAutomationTab />
                        )
                    }
                    </Card>
                </BaseLayout>
            )}
        </div>
    );
}
